import React, { ReactElement, useState } from "react";
import {
    AiFillCaretDown, AiFillCaretLeft, AiFillStar, AiOutlineStar,
} from "react-icons/ai";
import useKeyboardShortcuts from "../../../contexts/KeyboardShortcutContext";
import { useGetAiSignalsQuery } from "../../../__generated__/api";
import { LoadingIcon } from "../../loading/Loading";

const KEYBOARD_CONTEXT = "chat";

export function AILine({
    title, value,
}: {
    title: string;
    value: string | undefined | null;
}) {
    return value ? (
        <div className="my-2">
            <small className="text-gray-500">{title}</small>
            <div>
                {value}
            </div>
        </div>
    ) : null;
}

const MAX_STARS = [1, 2, 3, 4, 5];

export default function ArtificialIntelligence({
    chatId,
}: {
    chatId: string
}): ReactElement {
    const [shouldShow, setShouldShow] = useState<boolean>(false);

    const { data, loading: isLoading } = useGetAiSignalsQuery({
        skip: !shouldShow,
        variables: {
            chatId,
        },
    });

    useKeyboardShortcuts(shortcuts => {
        shortcuts.on({
            shortcut: "shift+cmd+a",
            context: KEYBOARD_CONTEXT,
            handler: () => {
                setShouldShow(true);
            },
        });
    });

    const satisfaction = data?.summarizeConversation?.expectedSatisfaction ?? 0;

    return (

        <div>
            <div className="d-flex justify-content-between align-items-center mt-4 mb-1">
                <h6 className="p-0 m-0">
                    AI Analysis
                </h6>
                <button
                    type="button"
                    className="btn btn-none p-0 m-0"
                    onClick={() => setShouldShow(current => !current)}
                >
                    {shouldShow
                        ? <AiFillCaretDown className="text-gray-400" />
                        : <AiFillCaretLeft className="text-gray-400" />}
                </button>
            </div>
            {shouldShow && (
                isLoading ? (
                    <LoadingIcon />
                ) : (
                    <div className="">
                        {!data?.summarizeConversation && (
                            <small className="text-gray-500 fst-italic">
                                No AI analysis for this conversation
                            </small>
                        )}
                        <AILine title="Summary" value={data?.summarizeConversation?.summary} />
                        <AILine title="Sentiment" value={data?.summarizeConversation?.sentiment} />
                        <AILine title="Tone" value={data?.summarizeConversation?.agentTone} />
                        {satisfaction > 0 && (
                            <div className="my-2">
                                <small className="text-gray-500">Expected Satisfaction</small>
                                <div>
                                    {MAX_STARS.map(index => (
                                        index <= satisfaction ? <AiFillStar /> : <AiOutlineStar />
                                    ))}
                                </div>
                            </div>
                        )}

                        <AILine title="Recommendation" value={data?.summarizeConversation?.recommendation} />
                    </div>
                )
            )}

        </div>

    );
}
